import { applyOverrides } from '../../../shared';
import { leaseAgreementDatesCard as baseCard } from '../../shared';

export const leaseAgreementDatesCard = applyOverrides(baseCard, {
  fields: {
    paymentDate: {
      validation: [{ type: 'required', message: 'Required' }],
    },
  },
});
